import analyticsRun from './analytics.run';

export default angular.module('start.core.analytics', [
  'angulartics.google.analytics',
  'rhino.components.application',
])
  .run(analyticsRun)
  .name;



// WEBPACK FOOTER //
// ./components/analytics/analytics.module.js